import i18n from "@/i18n";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";
import weightInput from "./column/weightInput.vue";

export const columns = [
    {
        colId: "check",
        type: "Checkbox",
        header: "",
        width: "37px"
    },
    {
        type: "Text",
        colId: "entity_group_id",
        header: "ID",
        width: "100px"
    },
    {
        type: "Link",
        colId: "entity_group_name",
        header: "实体组名称"
    },
    {
        type: "LineBreakText",
        colId: "relationQuestion",
        header: "关联标问ID"
    },
    {
        component: weightInput,
        colId: "weight",
        header: "执行优先级",
        width: "100px",
        tooltip: i18n.t("zhiji.EntityManagement.priorityTip")
    },
    {
        type: "LineBreakText",
        colId: "creator",
        header: "创建人",
        width: "180px"
    },
    {
        type: "LineBreakText",
        colId: "operator",
        header: "最后编辑",
        width: "180px"
    },
    {
        type: "Status",
        colId: "mapStatus",
        header: "状态",
        width: "100px"
    },
    {
        type: "Operation",
        colId: "operation",
        header: "操作"
    }
];

export const bottomButtons = [
    {
        id: "del",
        text: i18n.t("zhiji.common.delete"),
        icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
        hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px -22px"
    },
    {
        id: "online",
        text: "上线",
        icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -210px 0px",
        hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -210px -20px"
    },
    {
        id: "offline",
        text: "下线",
        icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -230px 0px",
        hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -230px -20px"
    },
    {
        id: "transfer",
        text: i18n.t("zhiji.knowlege.transferTo"),
        icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -191px 0px",
        hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -191px -20px",
        type: "OptionButton",
        options: []
    }
];

export const searchFilter = [
    {
        props: {
            name: "filterFields",
            inline: true,
            subItemLabelPosition: "left"
        },
        uId: "0",
        cid: "Form",
        events: [],
        children: [
            {
                props: {
                    style: {
                        width: "200px"
                    },
                    options: [
                        {
                            label: "所有状态",
                            value: ""
                        },
                        {
                            label: "已上线",
                            value: "1"
                        },
                        {
                            label: "未上线",
                            value: "0"
                        }
                    ],
                    name: "status"
                },
                uId: "1",
                cid: "Elselector",
                events: [],
                children: []
            },
            {
                props: {
                    style: {},
                    options: [
                        {
                            label: "按实体组名称",
                            value: "entity_group_name"
                        },
                        {
                            label: "按实体组id",
                            value: "entity_group_id"
                        },
                        {
                            label: "按兜底标问id",
                            value: "question_id"
                        }
                    ],
                    name: "keyWordSearch"
                },
                uId: "3",
                cid: "CombinedSearch",
                events: [],
                children: []
            }
        ]
    }
];
